/* eslint-disable */

import React, { useMemo, useState } from "react";
import SuperAdminOverview from "./SuperAdminOverview";
import SuperAdminSchools from "./SuperAdminSchools";
import "./SuperAdminDashboard.css";

const NAV_ITEMS = [
  {
    id: "overview",
    label: "Overview",
    description: "Agreements, demo activity and onboarding",
  },
  {
    id: "schools",
    label: "Schools",
    description: "Activated PresentPlus school tenants",
  },
];

export default function SuperAdminDashboard() {
  const initialView = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("view") === "schools" ? "schools" : "overview";
  }, []);

  const [activeView, setActiveView] = useState(initialView);

  function changeView(nextView) {
    setActiveView(nextView);

    const url = new URL(window.location.href);
    if (nextView === "overview") {
      url.searchParams.delete("view");
    } else {
      url.searchParams.set("view", nextView);
    }

    window.history.replaceState({}, "", url.toString());
    window.scrollTo({ top: 0, behavior: "smooth" });
  }

  return (
    <main className="pp-super-shell">
      <nav className="pp-super-nav" aria-label="Super Admin sections">
        <div className="pp-super-nav-brand">
          <span className="pp-super-nav-kicker">PresentPlus</span>
          <strong>Enterprise Operations</strong>
        </div>

        <div className="pp-super-nav-items">
          {NAV_ITEMS.map((item) => {
            const isActive = activeView === item.id;

            return (
              <button
                key={item.id}
                type="button"
                className={`pp-super-nav-button${isActive ? " is-active" : ""}`}
                onClick={() => changeView(item.id)}
                aria-current={isActive ? "page" : undefined}
              >
                <span className="pp-super-nav-button-label">{item.label}</span>
                <span className="pp-super-nav-button-description">
                  {item.description}
                </span>
              </button>
            );
          })}
        </div>

        <button
          type="button"
          className="pp-super-nav-crm"
          onClick={() => {
            window.location.href = "/super-admin/demo-requests";
          }}
        >
          Open Demo CRM
        </button>
      </nav>

      <section className="pp-super-content">
        {activeView === "schools" ? (
          <div className="pp-schools-polish"><SuperAdminSchools /></div>
        ) : (
          <SuperAdminOverview />
        )}
      </section>
    </main>
  );
}
